<template>
    <div class="box">

        <div class="handle-box-search">




            <el-row type="flex" justify="center" style="margin-bottom: 20px;">

                <span style="display: inline-block;width: 70px;text-align: right; margin-right: 5px;">密码:</span>
                <el-input v-model="submit_data.export_password" style="width: 200px;" show-password></el-input>



            </el-row>





            <div style="width: 500px; margin: 10px auto;" v-if="progress_show">

                <el-progress :percentage="progress_data"></el-progress>
                <i class="el-icon-loading"></i>
                正在导出...

            </div>

            <el-row type="flex" justify="center" v-else>

                <el-button type="primary" @click="toExport">导出</el-button>


            </el-row>



        </div>




    </div>

</template>

<script>
    var _this;
    export default {

        data() {
            return {


                submit_data: {
                    page: 1,
                    export_password:''
                },

                excelData: [],

                excelHead: [],

                progress_show: false,
                progress_data: 0

            };
        },
        created() {
            _this = this;
            console.log(this.$route.path);

        },

        methods: {
            toExport() {


                _this.getExcelData();

            },

            getExcelData() {

                _this.$post(
                    "/order/getDriverTrueCSV",
                    _this.submit_data
                ).then(res => {

                    _this.progress_show = true;

                    if (this.$route.path == '/getDriverTrueCSV') {


                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.list.length; i++) {

                            _this.excelData.push({
                                'phone': res.data.list[i].phone,
                                'real_name': res.data.list[i].real_name,
                                'time': res.data.list[i].time,
                                'signing_time': res.data.list[i].signing_time,
                                'capacity': res.data.list[i].capacity,
                                'driver_or_legwork': res.data.list[i].driver_or_legwork,
                                'name': res.data.list[i].name,
                                'signing_type': res.data.list[i].signing_type,
                                'exponentDriverPoints_':res.data.list[i].exponentDriverPoints_
                            });


                        }



                        if (res.data.page * res.data.limit < res.data.count) {

                            _this.submit_data.page = res.data.page + 1;

                            _this.progress_data = Math.floor((res.data.page * res.data.limit / res.data.count) * 100);

                            _this.getExcelData();

                        } else {

                            // console.log(_this.excelData);

                            // 将数据导出execl
                            _this.exportData();

                            _this.submit_data.page = 1;

                            // 清空数据
                            _this.excelData = [];

                            _this.progress_show = false;
                            _this.progress_data = 0;


                        }

                    } else {

                        _this.progress_show = false;
                        _this.progress_data = 0;

                    }



                }).catch((err) => {

                })

            },


            // 导出excel方法
            exportData() {
                const {
                    export_json_to_excel
                } = require('@/vendor/Export2Excel');
                const tHeader = ['真实姓名', '签约类型', '工作类型', '职位', '城市小组', '司机电话', '到期时间','签约时间','司机综合分数'];
                const filterVal = ['real_name', 'signing_type', 'driver_or_legwork', 'capacity', 'name', 'phone', 'time','signing_time','exponentDriverPoints_'];
                const list = this.excelData;
                const data = this.formatJson(filterVal, list);
                export_json_to_excel(tHeader, data, 'fileName');
            },

            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },



        }
    };
</script>

<style scoped>

</style>
